import { render, staticRenderFns } from "./CustomerInquiry.vue?vue&type=template&id=1c159724&scoped=true&"
import script from "./CustomerInquiry.vue?vue&type=script&lang=js&"
export * from "./CustomerInquiry.vue?vue&type=script&lang=js&"
import style0 from "./CustomerInquiry.vue?vue&type=style&index=0&id=1c159724&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c159724",
  null
  
)

export default component.exports